import PropTypes from "prop-types";

export const userPropType = PropTypes.shape({
	admin_url: PropTypes.oneOf([PropTypes.string, null]),
	country: PropTypes.string,
	email: PropTypes.string,
	first_name: PropTypes.string,
	is_active: PropTypes.bool,
	last_name: PropTypes.string,
});